// import { useDeleteUserById } from "../../../lib/api-referral";
import {
  Badge,
  Card,
  CardFooter,
  Media,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table,
  Row,
  Button,
} from "reactstrap";

const UsersTable = ({ usersData, onAddToken, isLoading }) => {
  console.log(usersData, "usersData");
  return (
    <Row>
      <div className="col">
        <Card className="shadow">
          {/* <CardHeader className="border-0">
            <Row className="align-items-center">
              <div className="col">
                <h3 className="mb-0">Tokens Management</h3>
              </div>
              <div className="col text-right">
                <Button
                  color="primary"
                  onClick={onAddToken}
                  size="sm"
                  disabled={isLoading}
                >
                  {isLoading ? "Adding..." : "Add New Token"}
                </Button>
              </div>
            </Row>
          </CardHeader> */}

          <Table className="align-items-center table-flush" responsive>
            <thead className="thead-light">
              <tr>
                <th scope="col">User</th>
                <th scope="col">Referral Code</th>
                <th scope="col">Referred Count</th>
                <th scope="col">Reward</th>
                <th scope="col">Created At</th>
                <th scope="col" />
              </tr>
            </thead>
            <tbody>
              {usersData?.data?.length > 0 ? (
                usersData?.data?.map((user) => (
                  <UserRow key={user._id} user={user} />
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center py-4">
                    <p className="text-muted mb-0">No users found</p>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          <CardFooter className="py-4">
            {usersData?.data?.length > 10 && (
              <nav aria-label="...">
                <Pagination
                  className="pagination justify-content-end mb-0"
                  listClassName="justify-content-end mb-0"
                >
                  <PaginationItem className="disabled">
                    <PaginationLink
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                      tabIndex="-1"
                    >
                      <i className="fas fa-angle-left" />
                      <span className="sr-only">Previous</span>
                    </PaginationLink>
                  </PaginationItem>
                  {usersData?.data?.length > 10 &&
                    usersData?.data?.length <= 20 && (
                      <>
                        <PaginationItem className="active">
                          <PaginationLink
                            href="#pablo"
                            onClick={(e) => e.preventDefault()}
                          >
                            1
                          </PaginationLink>
                        </PaginationItem>
                        <PaginationItem>
                          <PaginationLink
                            href="#pablo"
                            onClick={(e) => e.preventDefault()}
                          >
                            2 <span className="sr-only">(current)</span>
                          </PaginationLink>
                        </PaginationItem>
                      </>
                    )}

                  {usersData?.data?.length > 20 &&
                    usersData?.data?.length <= 30 && (
                      <PaginationItem>
                        <PaginationLink
                          href="#pablo"
                          onClick={(e) => e.preventDefault()}
                        >
                          3
                        </PaginationLink>
                      </PaginationItem>
                    )}
                  <PaginationItem>
                    <PaginationLink
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                    >
                      <i className="fas fa-angle-right" />
                      <span className="sr-only">Next</span>
                    </PaginationLink>
                  </PaginationItem>
                </Pagination>
              </nav>
            )}
          </CardFooter>
        </Card>
      </div>
    </Row>
  );
};

const UserRow = ({ user }) => {
  //   const deleteUserMutation = useDeleteUserById(user._id);

  const handleDelete = () => {
    if (window.confirm("Are you sure you want to delete this user?")) {
      //   deleteUserMutation.mutate();
    }
  };

  return (
    <tr>
      <th scope="row">
        <Media className="align-items-center">
          <a
            className="avatar rounded-circle mr-3"
            href="#pablo"
            onClick={(e) => e.preventDefault()}
          >
            <img
              className="rounded-circle avatar bg-white"
              alt={user.name}
              src={user?.profileImage}
              onError={(e) => {
                e.target.src = require("../../../assets/img/theme/bootstrap.jpg");
              }}
            />
          </a>
          <Media className="d-flex flex-column ">
            <span className="mb-0 text-sm font-weight-bold">{user?.name}</span>
            <br />
            <small className="text-muted">{user?.email}</small>
          </Media>
        </Media>
      </th>
      <td>
        <span className="font-weight-bold">{user?.referralCode}</span>
      </td>
      <td>
        <small className="text-muted">{user?.referredCount}</small>
      </td>
      <td>
        <small className="text-muted">{user?.reward}</small>
      </td>
      <td>
        {user?.createdAt
          ? new Date(user?.createdAt).toLocaleDateString()
          : "N/A"}
      </td>
      <td className="">
        <Button
          color="danger"
          onClick={handleDelete}
          //   disabled={deleteUserMutation.isLoading}
        >
          {/* {deleteUserMutation.isLoading ? "Deleting..." : "Delete"} */}
        </Button>
      </td>
    </tr>
  );
};

export default UsersTable;
